import React, { useState, Component } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { CalendarIcon, MapPinIcon, ClockIcon, UsersIcon, CheckSquareIcon, FileTextIcon, NavigationIcon, AlertTriangleIcon, ChevronDownIcon, ChevronUpIcon, CheckIcon, XIcon } from 'lucide-react';
// Mock data for instructor trainings
const mockTrainings = [{
  id: 1,
  date: new Date(),
  startTime: new Date(new Date().setHours(9, 0)),
  endTime: new Date(new Date().setHours(12, 0)),
  type: 'Sliptraining Basis',
  location: 'Rotterdam',
  address: 'Slipbaanweg 10, 3045 Rotterdam',
  client: 'Gemeente Rotterdam',
  participants: [{
    id: 1,
    name: 'Jan Janssen',
    email: 'j.janssen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 2,
    name: 'Piet Pietersen',
    email: 'p.pietersen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 3,
    name: 'Klaas Klaassen',
    email: 'k.klaassen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 4,
    name: 'Henk Hendriks',
    email: 'h.hendriks@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 5,
    name: 'Sjaak Sjaaksen',
    email: 's.sjaaksen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }, {
    id: 6,
    name: 'Willem Willemsen',
    email: 'w.willemsen@bedrijf.nl',
    company: 'Gemeente Rotterdam',
    present: null,
    notes: ''
  }],
  status: 'upcoming',
  color: 'blue',
  notes: ''
}, {
  id: 2,
  date: new Date(),
  startTime: new Date(new Date().setHours(13, 30)),
  endTime: new Date(new Date().setHours(16, 30)),
  type: 'Defensief Rijden',
  location: 'Utrecht',
  address: 'Defensieweg 5, 3584 Utrecht',
  client: 'ProRail',
  participants: [{
    id: 7,
    name: 'Anna Bakker',
    email: 'a.bakker@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }, {
    id: 8,
    name: 'Peter Post',
    email: 'p.post@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }, {
    id: 9,
    name: 'Maria Visser',
    email: 'm.visser@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }, {
    id: 10,
    name: 'Thomas Berg',
    email: 't.berg@prorail.nl',
    company: 'ProRail',
    present: null,
    notes: ''
  }],
  status: 'upcoming',
  color: 'green',
  notes: ''
}, {
  id: 3,
  date: new Date(new Date().setDate(new Date().getDate() + 1)),
  startTime: new Date(new Date().setDate(new Date().getDate() + 1)).setHours(9, 0),
  endTime: new Date(new Date().setDate(new Date().getDate() + 1)).setHours(12, 0),
  type: 'Sliptraining Gevorderd',
  location: 'Rotterdam',
  address: 'Slipbaanweg 10, 3045 Rotterdam',
  client: 'Shell Nederland',
  participants: [{
    id: 11,
    name: 'Erik Eriksen',
    email: 'e.eriksen@shell.com',
    company: 'Shell Nederland',
    present: null,
    notes: ''
  }, {
    id: 12,
    name: 'Lisa Bakker',
    email: 'l.bakker@shell.com',
    company: 'Shell Nederland',
    present: null,
    notes: ''
  }, {
    id: 13,
    name: 'Mark Marksen',
    email: 'm.marksen@shell.com',
    company: 'Shell Nederland',
    present: null,
    notes: ''
  }, {
    id: 14,
    name: 'Sophie Jansen',
    email: 's.jansen@shell.com',
    company: 'Shell Nederland',
    present: null,
    notes: ''
  }, {
    id: 15,
    name: 'Robert Robertsen',
    email: 'r.robertsen@shell.com',
    company: 'Shell Nederland',
    present: null,
    notes: ''
  }],
  status: 'upcoming',
  color: 'purple',
  notes: ''
}, {
  id: 4,
  date: new Date(new Date().setDate(new Date().getDate() - 1)),
  startTime: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(10, 0),
  endTime: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(13, 0),
  type: 'Code 95 Training',
  location: 'Amsterdam',
  address: 'Transportweg 8, 1043 Amsterdam',
  client: 'Transport BV',
  participants: [{
    id: 16,
    name: 'Hans Hansen',
    email: 'h.hansen@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 17,
    name: 'Petra Peters',
    email: 'p.peters@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 18,
    name: 'Johan Johanssen',
    email: 'j.johanssen@transport.nl',
    company: 'Transport BV',
    present: false,
    notes: 'Ziek gemeld'
  }, {
    id: 19,
    name: 'Bart Bartels',
    email: 'b.bartels@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 20,
    name: 'Gerrit Gerrits',
    email: 'g.gerrits@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 21,
    name: 'Dirk Dirksen',
    email: 'd.dirksen@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }, {
    id: 22,
    name: 'Karel Karels',
    email: 'k.karels@transport.nl',
    company: 'Transport BV',
    present: true,
    notes: ''
  }],
  status: 'completed',
  color: 'yellow',
  notes: 'Training is goed verlopen. Deelnemers waren enthousiast over de praktijkoefeningen.'
}];
// Helper function to format time
const formatTime = date => {
  return date.toLocaleTimeString('nl-NL', {
    hour: '2-digit',
    minute: '2-digit'
  });
};
// Helper function to format date
const formatDate = date => {
  return date.toLocaleDateString('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
};
// Helper function to get status badge
const getStatusBadge = status => {
  switch (status) {
    case 'upcoming':
      return <Badge variant="info" data-id="element-1490">Gepland</Badge>;
    case 'completed':
      return <Badge variant="success" data-id="element-1491">Afgerond</Badge>;
    case 'cancelled':
      return <Badge variant="danger" data-id="element-1492">Geannuleerd</Badge>;
    default:
      return <Badge variant="default" data-id="element-1493">Onbekend</Badge>;
  }
};
// Helper function to get training type color
const getTrainingTypeColor = color => {
  const colorMap = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    purple: 'bg-purple-100 text-purple-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    red: 'bg-red-100 text-red-800'
  };
  return colorMap[color] || 'bg-gray-100 text-gray-800';
};
// Filter trainings by date range
const filterTrainingsByDateRange = (trainings, filter) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const nextWeek = new Date(today);
  nextWeek.setDate(nextWeek.getDate() + 7);
  switch (filter) {
    case 'today':
      return trainings.filter(training => {
        const trainingDate = new Date(training.date);
        trainingDate.setHours(0, 0, 0, 0);
        return trainingDate.getTime() === today.getTime();
      });
    case 'tomorrow':
      return trainings.filter(training => {
        const trainingDate = new Date(training.date);
        trainingDate.setHours(0, 0, 0, 0);
        return trainingDate.getTime() === tomorrow.getTime();
      });
    case 'week':
      return trainings.filter(training => {
        const trainingDate = new Date(training.date);
        trainingDate.setHours(0, 0, 0, 0);
        return trainingDate >= today && trainingDate < nextWeek;
      });
    case 'upcoming':
      return trainings.filter(training => {
        const trainingDate = new Date(training.date);
        trainingDate.setHours(0, 0, 0, 0);
        return trainingDate >= today;
      });
    case 'past':
      return trainings.filter(training => {
        const trainingDate = new Date(training.date);
        trainingDate.setHours(0, 0, 0, 0);
        return trainingDate < today;
      });
    case 'all':
    default:
      return trainings;
  }
};
export function MyTrainings() {
  const [activeTraining, setActiveTraining] = useState(null);
  const [filter, setFilter] = useState('upcoming');
  const [trainings, setTrainings] = useState(mockTrainings);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showSickReportModal, setShowSickReportModal] = useState(false);
  const [sickReportReason, setSickReportReason] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  // Filter trainings based on selected filter
  const filteredTrainings = filterTrainingsByDateRange(trainings, filter);
  // Handle opening training details
  const handleOpenTraining = trainingId => {
    setActiveTraining(activeTraining === trainingId ? null : trainingId);
  };
  // Handle attendance marking
  const handleAttendanceChange = (trainingId, participantId, present) => {
    setTrainings(trainings.map(training => {
      if (training.id === trainingId) {
        return {
          ...training,
          participants: training.participants.map(participant => {
            if (participant.id === participantId) {
              return {
                ...participant,
                present
              };
            }
            return participant;
          })
        };
      }
      return training;
    }));
  };
  // Handle notes update
  const handleNotesChange = (trainingId, notes) => {
    setTrainings(trainings.map(training => {
      if (training.id === trainingId) {
        return {
          ...training,
          notes
        };
      }
      return training;
    }));
  };
  // Handle participant notes update
  const handleParticipantNotesChange = (trainingId, participantId, notes) => {
    setTrainings(trainings.map(training => {
      if (training.id === trainingId) {
        return {
          ...training,
          participants: training.participants.map(participant => {
            if (participant.id === participantId) {
              return {
                ...participant,
                notes
              };
            }
            return participant;
          })
        };
      }
      return training;
    }));
  };
  // Handle saving attendance and notes
  const handleSaveAttendance = trainingId => {
    // In a real app, this would send the data to the server
    setSuccessMessage('Aanwezigheid en notities succesvol opgeslagen');
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };
  // Handle sick report submission
  const handleSickReportSubmit = () => {
    // In a real app, this would send the sick report to the server
    setShowSickReportModal(false);
    setSuccessMessage('Ziekmelding succesvol verstuurd');
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };
  // Handle opening navigation to training location
  const handleOpenNavigation = address => {
    // In a real app, this would open a maps app with the address
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
  };
  // Find active training object
  const activeTrainingObject = trainings.find(t => t.id === activeTraining);
  // Handle completing a training
  const handleCompleteTraining = trainingId => {
    setTrainings(trainings.map(training => {
      if (training.id === trainingId) {
        return {
          ...training,
          status: 'completed'
        };
      }
      return training;
    }));
    setSuccessMessage('Training succesvol afgerond');
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };
  return <div className="space-y-6" data-id="element-1494">
      <div className="flex justify-between items-center" data-id="element-1495">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1496">Mijn Trainingen</h1>
        <div className="flex space-x-2" data-id="element-1497">
          <div className="relative" data-id="element-1498">
            <select value={filter} onChange={e => setFilter(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#B61C1C] focus:border-[#B61C1C] sm:text-sm rounded-md" data-id="element-1499">
              <option value="today" data-id="element-1500">Vandaag</option>
              <option value="tomorrow" data-id="element-1501">Morgen</option>
              <option value="week" data-id="element-1502">Deze week</option>
              <option value="upcoming" data-id="element-1503">Aankomend</option>
              <option value="past" data-id="element-1504">Afgerond</option>
              <option value="all" data-id="element-1505">Alle trainingen</option>
            </select>
          </div>
          <Button variant="outline" size="sm" onClick={() => setShowSickReportModal(true)} className="text-red-600 border-red-300 hover:bg-red-50" data-id="element-1506">
            <AlertTriangleIcon className="h-4 w-4 mr-1" data-id="element-1507" />
            Ziek Melden
          </Button>
        </div>
      </div>

      {/* Success message */}
      {showSuccessMessage && <div className="fixed top-4 right-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded z-50 shadow-md flex items-center" data-id="element-1508">
          <CheckIcon className="h-5 w-5 mr-2" data-id="element-1509" />
          <span data-id="element-1510">{successMessage}</span>
        </div>}

      {/* Training list */}
      {filteredTrainings.length > 0 ? <div className="space-y-4" data-id="element-1511">
          {filteredTrainings.map(training => <Card key={training.id} className="overflow-hidden" data-id="element-1512">
              <div className="p-4 cursor-pointer hover:bg-gray-50" onClick={() => handleOpenTraining(training.id)} data-id="element-1513">
                <div className="flex justify-between items-start" data-id="element-1514">
                  <div className="flex items-start space-x-4" data-id="element-1515">
                    <div className="flex flex-col items-center justify-center w-16 h-16 bg-gray-100 rounded-lg" data-id="element-1516">
                      <span className="text-xs text-gray-500" data-id="element-1517">
                        {new Date(training.date).toLocaleDateString('nl-NL', {
                    weekday: 'short'
                  })}
                      </span>
                      <span className="text-lg font-bold text-gray-900" data-id="element-1518">
                        {new Date(training.date).getDate()}
                      </span>
                      <span className="text-xs text-gray-500" data-id="element-1519">
                        {new Date(training.date).toLocaleDateString('nl-NL', {
                    month: 'short'
                  })}
                      </span>
                    </div>
                    <div data-id="element-1520">
                      <div className="flex items-center" data-id="element-1521">
                        <span className={`px-2 py-1 rounded-md text-xs font-medium ${getTrainingTypeColor(training.color)}`} data-id="element-1522">
                          {training.type}
                        </span>
                        <span className="ml-2" data-id="element-1523">
                          {getStatusBadge(training.status)}
                        </span>
                      </div>
                      <h3 className="mt-1 text-sm font-medium text-gray-900" data-id="element-1524">
                        {training.client}
                      </h3>
                      <div className="mt-1 flex items-center text-sm text-gray-500" data-id="element-1525">
                        <ClockIcon className="h-4 w-4 mr-1" data-id="element-1526" />
                        <span data-id="element-1527">
                          {formatTime(new Date(training.startTime))} -{' '}
                          {formatTime(new Date(training.endTime))}
                        </span>
                      </div>
                      <div className="mt-1 flex items-center text-sm text-gray-500" data-id="element-1528">
                        <MapPinIcon className="h-4 w-4 mr-1" data-id="element-1529" />
                        <span data-id="element-1530">{training.location}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1531">
                    <UsersIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-1532" />
                    <span className="text-sm text-gray-500" data-id="element-1533">
                      {training.participants.length}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 ml-2 text-gray-400 transition-transform ${activeTraining === training.id ? 'rotate-180' : ''}`} data-id="element-1534" />
                  </div>
                </div>
              </div>
              {/* Training details */}
              {activeTraining === training.id && <div className="border-t border-gray-200 p-4 bg-gray-50" data-id="element-1535">
                  <div className="space-y-4" data-id="element-1536">
                    {/* Training info */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1537">
                      <div data-id="element-1538">
                        <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1539">
                          Datum & Tijd
                        </h4>
                        <p className="text-sm" data-id="element-1540">
                          {formatDate(new Date(training.date))}
                        </p>
                        <p className="text-sm" data-id="element-1541">
                          {formatTime(new Date(training.startTime))} -{' '}
                          {formatTime(new Date(training.endTime))}
                        </p>
                      </div>
                      <div data-id="element-1542">
                        <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1543">
                          Locatie
                        </h4>
                        <p className="text-sm" data-id="element-1544">{training.location}</p>
                        <p className="text-sm text-gray-500" data-id="element-1545">
                          {training.address}
                        </p>
                        <button className="mt-1 text-xs text-[#B61C1C] flex items-center hover:underline" onClick={() => handleOpenNavigation(training.address)} data-id="element-1546">
                          <NavigationIcon className="h-3 w-3 mr-1" data-id="element-1547" />
                          Open routeplanner
                        </button>
                      </div>
                      <div data-id="element-1548">
                        <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1549">
                          Klant
                        </h4>
                        <p className="text-sm" data-id="element-1550">{training.client}</p>
                        <p className="text-sm text-gray-500" data-id="element-1551">
                          {training.participants.length} deelnemers
                        </p>
                      </div>
                    </div>
                    {/* Actions */}
                    <div className="flex flex-wrap gap-2" data-id="element-1552">
                      {training.status === 'upcoming' && <>
                          <Button size="sm" variant="outline" data-id="element-1553">
                            <CheckSquareIcon className="h-4 w-4 mr-1" data-id="element-1554" />
                            Aanwezigheid Registreren
                          </Button>
                          <Button size="sm" variant="outline" data-id="element-1555">
                            <FileTextIcon className="h-4 w-4 mr-1" data-id="element-1556" />
                            Notities
                          </Button>
                          <Button size="sm" variant="outline" onClick={() => handleOpenNavigation(training.address)} data-id="element-1557">
                            <NavigationIcon className="h-4 w-4 mr-1" data-id="element-1558" />
                            Navigeer
                          </Button>
                          <Button size="sm" variant="primary" onClick={() => handleCompleteTraining(training.id)} data-id="element-1559">
                            <CheckIcon className="h-4 w-4 mr-1" data-id="element-1560" />
                            Training Afronden
                          </Button>
                        </>}
                      {training.status === 'completed' && <>
                          <Button size="sm" variant="outline" data-id="element-1561">
                            <FileTextIcon className="h-4 w-4 mr-1" data-id="element-1562" />
                            Bekijk Rapport
                          </Button>
                        </>}
                    </div>
                    {/* Participants */}
                    <div data-id="element-1563">
                      <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1564">
                        Deelnemers
                      </h4>
                      <div className="bg-white rounded-md border border-gray-200 overflow-hidden" data-id="element-1565">
                        <table className="min-w-full divide-y divide-gray-200" data-id="element-1566">
                          <thead className="bg-gray-50" data-id="element-1567">
                            <tr data-id="element-1568">
                              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1569">
                                Naam
                              </th>
                              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1570">
                                Bedrijf
                              </th>
                              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1571">
                                Aanwezig
                              </th>
                              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1572">
                                Notities
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200" data-id="element-1573">
                            {training.participants.map(participant => <tr key={participant.id} data-id="element-1574">
                                <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1575">
                                  {participant.name}
                                </td>
                                <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-1576">
                                  {participant.company}
                                </td>
                                <td className="px-4 py-2 whitespace-nowrap" data-id="element-1577">
                                  {training.status === 'upcoming' ? <div className="flex space-x-2" data-id="element-1578">
                                      <button className={`p-1 rounded ${participant.present === true ? 'bg-green-100 text-green-800 ring-2 ring-green-500' : 'bg-gray-100 text-gray-800 hover:bg-green-50'}`} onClick={() => handleAttendanceChange(training.id, participant.id, true)} title="Aanwezig" data-id="element-1579">
                                        <CheckIcon className="h-4 w-4" data-id="element-1580" />
                                      </button>
                                      <button className={`p-1 rounded ${participant.present === false ? 'bg-red-100 text-red-800 ring-2 ring-red-500' : 'bg-gray-100 text-gray-800 hover:bg-red-50'}`} onClick={() => handleAttendanceChange(training.id, participant.id, false)} title="Afwezig" data-id="element-1581">
                                        <XIcon className="h-4 w-4" data-id="element-1582" />
                                      </button>
                                    </div> : <span className={participant.present ? 'text-green-600' : 'text-red-600'} data-id="element-1583">
                                      {participant.present ? 'Aanwezig' : 'Afwezig'}
                                    </span>}
                                </td>
                                <td className="px-4 py-2" data-id="element-1584">
                                  {training.status === 'upcoming' ? <input type="text" placeholder="Notities..." className="w-full text-sm border-gray-300 rounded-md" value={participant.notes} onChange={e => handleParticipantNotesChange(training.id, participant.id, e.target.value)} data-id="element-1585" /> : <span className="text-sm text-gray-500" data-id="element-1586">
                                      {participant.notes || '-'}
                                    </span>}
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* Training notes */}
                    <div data-id="element-1587">
                      <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1588">
                        Trainingsnotities
                      </h4>
                      {training.status === 'upcoming' ? <textarea className="w-full p-2 text-sm border-gray-300 rounded-md" rows={3} placeholder="Voeg hier algemene notities toe over de training..." value={training.notes} onChange={e => handleNotesChange(training.id, e.target.value)} data-id="element-1589"></textarea> : <div className="p-3 bg-white border border-gray-200 rounded-md text-sm" data-id="element-1590">
                          {training.notes || 'Geen notities beschikbaar'}
                        </div>}
                    </div>
                    {/* Save button */}
                    {training.status === 'upcoming' && <div className="flex justify-end" data-id="element-1591">
                        <Button variant="primary" onClick={() => handleSaveAttendance(training.id)} data-id="element-1592">
                          <CheckIcon className="h-4 w-4 mr-1" data-id="element-1593" />
                          Opslaan
                        </Button>
                      </div>}
                  </div>
                </div>}
            </Card>)}
        </div> : <Card data-id="element-1594">
          <div className="p-6 text-center" data-id="element-1595">
            <CalendarIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" data-id="element-1596" />
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-1597">
              Geen trainingen gevonden
            </h3>
            <p className="text-gray-500" data-id="element-1598">
              Er zijn geen trainingen gevonden voor de geselecteerde periode.
            </p>
          </div>
        </Card>}

      {/* Sick report modal */}
      {showSickReportModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1599">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-1600">
            <div className="p-4 border-b border-gray-200" data-id="element-1601">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-1602">Ziekmelding</h3>
            </div>
            <div className="p-4" data-id="element-1603">
              <p className="text-sm text-gray-600 mb-4" data-id="element-1604">
                Je staat op het punt om je ziek te melden. Dit zal de planners
                informeren dat je niet beschikbaar bent voor geplande
                trainingen.
              </p>
              <div className="mb-4" data-id="element-1605">
                <label htmlFor="reason" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1606">
                  Reden (optioneel)
                </label>
                <textarea id="reason" rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Geef eventueel een reden op..." value={sickReportReason} onChange={e => setSickReportReason(e.target.value)} data-id="element-1607"></textarea>
              </div>
              <div className="mb-4" data-id="element-1608">
                <label htmlFor="period" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1609">
                  Verwachte duur
                </label>
                <select id="period" className="w-full p-2 border border-gray-300 rounded-md" data-id="element-1610">
                  <option value="1" data-id="element-1611">1 dag</option>
                  <option value="2" data-id="element-1612">2 dagen</option>
                  <option value="3" data-id="element-1613">3 dagen</option>
                  <option value="4" data-id="element-1614">4 dagen</option>
                  <option value="5" data-id="element-1615">5 dagen</option>
                  <option value="unknown" data-id="element-1616">Onbekend</option>
                </select>
              </div>
            </div>
            <div className="flex justify-end space-x-2 p-4 border-t border-gray-200 bg-gray-50" data-id="element-1617">
              <Button variant="outline" onClick={() => setShowSickReportModal(false)} data-id="element-1618">
                Annuleren
              </Button>
              <Button variant="primary" onClick={handleSickReportSubmit} className="bg-red-600 hover:bg-red-700" data-id="element-1619">
                <AlertTriangleIcon className="h-4 w-4 mr-1" data-id="element-1620" />
                Ziek Melden
              </Button>
            </div>
          </div>
        </div>}
    </div>;
}